import { } from 'react';

export default function Hero() {
  return (
    <section className="relative bg-gradient-to-b from-teal-50/30 to-white">
      <div className="absolute inset-0 bg-gradient-to-b from-teal-50/20 via-white/50 to-white"></div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-20 flex flex-col items-center text-center">

        {/* Logo */}
        <div className="mb-6 sm:mb-8">
          <img
            src="https://static.readdy.ai/image/81c0d91d09d1396d9a4289b3cac449c6/94d49a906157f4a6ae6acc44a6c5075b.png"
            alt="Logo"
            className="h-24 sm:h-32 lg:h-44 w-auto mx-auto"
          />
        </div>

        {/* Headline */}
        <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-gray-900 leading-tight mb-4 sm:mb-6">
          Você não está errando ao cuidar.
        </h1>

        {/* Subheadline */}
        <p className="text-base sm:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-10 max-w-2xl">
          Você só não foi ensinada a lidar com o <span className="text-teal-600 font-semibold">Alzheimer</span> sem gerar crises.
        </p>

        {/* Vídeo centralizado e grande */}
        <div className="w-full mb-8 sm:mb-10">
          <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl" style={{ paddingTop: '56.25%' }}>
            <iframe
              src="https://player.vimeo.com/video/1179714497?badge=0&autopause=0&player_id=0&app_id=58479"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              className="absolute inset-0 w-full h-full"
              title="Vídeo de apresentação"
            ></iframe>
          </div>
        </div>

        {/* Prova rápida */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 mb-8 sm:mb-10 w-full justify-center">
          <div className="flex items-center gap-2 justify-center">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
            </div>
            <p className="text-gray-700 text-sm sm:text-base">Criado por neurologista especialista em Alzheimer</p>
          </div>
          <div className="flex items-center gap-2 justify-center">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
            </div>
            <p className="text-gray-700 text-sm sm:text-base">Estratégias práticas para cuidadores</p>
          </div>
          <div className="flex items-center gap-2 justify-center">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
            </div>
            <p className="text-gray-700 text-sm sm:text-base">Protocolos simples para situações difíceis</p>
          </div>
        </div>

        {/* Botão CTA */}
        <div className="space-y-2 w-full max-w-xl">
          <a
            href="https://pay.hotmart.com/U103348916W?checkoutMode=10"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full bg-teal-600 hover:bg-teal-700 text-white font-bold px-6 py-4 rounded-lg text-base sm:text-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer text-center whitespace-nowrap"
          >
            Sim, quero aprender a prevenir crises agora
          </a>
          <p className="text-center text-sm text-gray-500">
            Acesso imediato · Garantia de 7 dias
          </p>
        </div>

      </div>
    </section>
  );
}
